/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import unset from 'lodash/unset';
import * as types from '../constants/actions';

const INITIALSTATE = {
    summary: [],
    displayValidationError: false,
};

const validations = (state = INITIALSTATE, action) => {
    let st = { ...state };

    switch (action.type) {
        case types.SET_VALIDATION_ERROR:
            st = cloneDeep(state);
            const { path, error } = action.payload;

            if (error) {
                set(st, path, error);
                st.summary = [
                    ...st.summary.filter((err) => err.path !== path),
                    { path, error },
                ];
            } else {
                unset(st, path, error);
                st.summary = [...st.summary.filter((err) => err.path !== path)];
            }
            return st;
        case types.CLEAR_VALIDATION_ERROR:
            st = cloneDeep(state);
            unset(st, path, error);
            st.summary = [
                ...st.summary.filter((err) => !err.path.startsWith('undefined_')),
            ];
            return st;
        case types.DISPLAY_UI_VALIDATIONS:
            st.displayValidationError = action.payload.shouldDisplay;
            return st;
        default:
            return st;
    }
};

export default validations;

export const selectors = {
    getValidations: (state) => {
        return state.huntingpermit.validations;
    },
};
